<template>
    <el-card shadow="never" style="margin-bottom: 10px;margin-top: -10px">
        <h1>会议室预约申请</h1>
        <el-form :model="formData" label-width="150px" :rules="rules">
            <el-form-item label="预约日期：" prop="star">
                <el-date-picker style="width: 250px" v-model="formData.borrow_data" type="date" placeholder="选择日期" ></el-date-picker>
            </el-form-item>
            <el-form-item label="会议室：" prop="star">
                <el-select v-model="formData.conference_id" style="width: 250px" clearable>
                    <el-option  v-for="item in conferenceName" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="开始时间：" prop="star">
                <el-time-picker
                        v-model="formData.start_time"
                        :picker-options="{selectableRange: '8:00:00 - 20:30:00'}"
                        placeholder="请选择时间"
                        style="width: 250px">
                </el-time-picker>
            </el-form-item>
            <el-form-item label="结束时间：" prop="star">
                <el-time-picker
                        v-model="formData.end_time"
                        :picker-options="{selectableRange: '8:00:00 - 20:30:00'}"
                        placeholder="请选择时间"
                        style="width: 250px">
                </el-time-picker>
            </el-form-item>
            <el-form-item>
                <el-button @click="submit" :loading="loading">提交</el-button>
            </el-form-item>
        </el-form>
    </el-card>
</template>
<script>
    import moment from 'moment/moment'
    moment.locale('zh-cn')
    export default {
        name: "ConferenceApply",
        props: {
            params: {
                type: Object,
                default: () => {
                    return {}
                }
            }
        },
        data() {
            return {
                dialogVisible: false,
                conferenceName:[],
                formData: {
                    borrow_data:'',
                    conference_id:'',
                    start_time:'',
                    end_time:''
                },
                rules: {
                    star: [{required: true, message: '', trigger: 'blur'}],
                }
            }
        },
        computed: {

        },
        methods: {
            reset() {
                //清空表单数据
                console.log('reset 被调用了');
                this.formData.borrow_data = ''
                this.formData.conference_id = ''
                this.formData.start_time = ''
                this.formData.end_time = ''

            },
            init(){

            },
            submit() {

                if (!this.formData.borrow_data) {
                    return this.$message.error('预约日期不能为空')
                }
                if (!this.formData.conference_id) {
                    return this.$message.error('会议室不能为空')
                }
                if (!this.formData.start_time) {
                    return this.$message.error('开始时间不能为空')
                }
                if (!this.formData.end_time) {
                    return this.$message.error('结束时间不能为空')
                }

                this.formData.borrow_data = moment(new Date(this.formData.borrow_data)).format('yyyy-MM-DD')
                this.formData.start_time = moment(new Date(this.formData.start_time)).format('HH:mm:ss')
                this.formData.end_time = moment(new Date(this.formData.end_time)).format('HH:mm:ss')

                this.loading = true;
                this.$axios.post('conference/submit', this.formData).then(response => {
                    this.loading = false;
                    let res = response.data
                    if (res.code != 0) {
                        return this.$message.error("提交失败");
                    }
                        return this.$message.success("提交成功");

                    this.formData.borrow_data = ''
                    this.formData.conference_id = ''
                    this.formData.start_time = ''
                    this.formData.end_time = ''
                })
            },
            getConferenceName() {
                this.$axios.post('conference/getConferenceName').then(response => {
                    let res = response.data
                    if (res.code != 0) {
                        return this.$message.error("获取失败");
                    }
                    this.conferenceName = res.data.itemList;
                })
            }

        },created() {
            this.getConferenceName()
        }
    }
</script>

<style scoped>
    .photo {
        display: flex;
        flex-wrap: nowrap;
        position: relative;
        box-sizing: border-box;
        align-items: flex-start;
    }

</style>